import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

import InfoFormPage from "../pages/Form/InfoForm.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    // component: Home,
    redirect: "/form", // App này Form là mặc định
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/taskpane",
    name: "Taskpane",
    redirect: "/form", // App này Form là mặc định
  },
  {
    path: "/form",
    name: "InfoForm",
    component: InfoFormPage,
  },
  {
    path: "/auth",
    name: "Authpage",
    component: () => import("../pages/Auth/index"),
  },
  {
    path: "/auth/login",
    name: "AuthpageLogin",
    component: () => import("../pages/Auth/index"),
  },
  {
    path: "/templates",
    name: "WordTemplates",
    component: () => import("../pages/WordTemplates.vue"),
  },
  {
    path: "/contentcontrol",
    name: "ContentControl",
    component: () => import("../pages/ContentControl.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
